module.exports = __webpack_public_path__ + "img/logo.23b4b54e.png";